module.exports = __webpack_public_path__ + "img/propertycontrol4.88107268.png";